import { setFetchStartState } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const VoucherApplicationsReducer = (state = {}, action) => {
    const { type, payload } = action;
    const key = payload && payload.tenantId;
    switch (type) {
        case actionTypes.FETCH_VOUCHER_APPLICATIONS_START:
            return {
                ...state,
                [key]: { ...setFetchStartState(state[key], payload.res) },
            };
        case actionTypes.FETCH_VOUCHER_APPLICATIONS_SUCCESS:
        case actionTypes.FETCH_VOUCHER_APPLICATIONS_ERROR:
            return {
                ...state,
                [key]: { ...payload.res },
            };
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map